import { axiosInstance } from "@/helper/axios-instance";
import { DataAwareResponse, User, UserUpdate } from "../types/types";
import { useMutationWithValidation } from "./useMutationWithValidation";

export function useUserUpdate() {
  return useMutationWithValidation({
    mutationFn: async (newUser: Partial<User>) => {
      const response = await axiosInstance({
        method: "POST",
        url:  `SystemUser/Update`,
        data: newUser,
      });

      return response.data as DataAwareResponse<UserUpdate>;
    },
    retry: 2,
  });
}
